export default "__VITE_ASSET__DRFLhMJG__"